import { 
  FILTERS_BLOCK_1,
 } from '@/constants'

export const LISTINGS_FILTERS = {
  filter_blocks: [
    FILTERS_BLOCK_1,
  ]
}

export const PRODUCT_DETAILS_FIELDS = [
  {
    field: 'set',
    label: 'Set',
    type: 'text',
  },
  {
    field: 'team',
    label: 'Team',
    type: 'text',
  },
  {
    field: 'year',
    label: 'Year',
    type: 'number',
  },
  {
    field: 'brand',
    label: 'Brand',
    type: 'text',
  },
  {
    field: 'card_number',
    label: 'Card Number',
    type: 'number',
  },
  {
    field: 'player',
    label: 'Name',
    type: 'text',
  },
  {
    field: 'attributes',
    label: 'Attributes',
    type: 'text',
  },
  {
    field: 'sports',
    label: 'Category',
    type: 'text',
  },
  {
    field: 'subset',
    label: 'Subset / Parallel',
    type: 'text'
  },
  {
    field: 'variation',
    label: 'Variation',
    type: 'text',
  },
  {
    field: 'serial_number',
    label: 'Serial Number',
    type: 'text',
  },
]

export const LISTING_STATUS = {
  'accepting_offers': {
    key: 'accepting_offers',
    label: 'Accepting Offers',
    icon: 'heroicons:hand-money',
  },
  'for_sale': {
    key: 'for_sale',
    label: 'For Sale',
    icon: 'heroicons:tag',
  },
  'sold_out': {
    key: 'sold_out',
    label: 'Sold Out',
    icon: 'heroicons:tag',
  },
  'sold_on': {
    key: 'sold_on',
    label: 'Sold On',
    icon: 'heroicons:tag',
  },
  'ended': {
    key: 'ended',
    label: 'Ended',
    icon: 'heroicons:tag',
  },
}
